import { t as createLogger } from "./app.shared-CmP4XLF_.js";

import { t as debounce } from "./app.shared-OQDvbu1B.js";

var log = createLogger("pdp-widget-anchor");

var MOBILE_MQ = "(max-width: 1024px)";

var ZONE_RATIO = .4;

var ZONE_MIN_PX = 200;

var ZONE_MAX_PX = 340;

var EDGE_BUFFER_PX = 8;

var SOURCE = "pdp-media-anchor";

var WIDGET_ID = "census";

var NUDGE_EVENT = "global-ui:nudge";

var NUDGE_REQUEST_EVENT = "global-ui:nudge-request";

var pdp_widget_anchor_default = (() => {
    const gallery = document.querySelector("product-gallery");
    const caption = gallery?.querySelector("[data-model-caption]");
    const track = gallery?.querySelector("[data-product-media-track]");
    const anchor = caption || track;
    if (!gallery || !anchor) return;
    const mobileMq = window.matchMedia(MOBILE_MQ);
    let observer = null;
    let active = false;
    let frameRaf = null;
    let lastEdgeY = null;
    const getWidget = () => document.querySelector(`[data-app-widget-id="${WIDGET_ID}"]`);
    const emitEdge = (edgeY, force = false) => {
        if (!force && edgeY === lastEdgeY) return;
        lastEdgeY = edgeY;
        log("ui", "dispatch global-ui:nudge", {
            lane: "bottom-left",
            source: SOURCE,
            edgeY: edgeY
        });
        document.dispatchEvent(new CustomEvent(NUDGE_EVENT, {
            detail: {
                lane: "bottom-left",
                source: SOURCE,
                edgeY: edgeY
            }
        }));
    };
    const measureEdgeY = () => {
        const anchorRect = anchor.getBoundingClientRect();
        return Math.floor(caption ? anchorRect.top - EDGE_BUFFER_PX : anchorRect.bottom);
    };
    const scheduleFrame = () => {
        if (frameRaf !== null) return;
        frameRaf = requestAnimationFrame(() => {
            frameRaf = null;
            if (!active) return;
            emitEdge(measureEdgeY());
        });
    };
    const applyActive = nowActive => {
        if (nowActive === active) return;
        active = nowActive;
        log("lifecycle", "anchor zone state changed", {
            active: active
        });
        if (active) scheduleFrame(); else emitEdge(null);
    };
    const measureZone = () => {
        const zone = Math.min(ZONE_MAX_PX, Math.max(ZONE_MIN_PX, Math.round(window.innerHeight * ZONE_RATIO)));
        log("ui", "zone measured", {
            zone: zone,
            innerHeight: window.innerHeight,
            hasWidget: Boolean(getWidget())
        });
        return zone;
    };
    const buildObserver = () => {
        observer?.disconnect();
        const zone = measureZone();
        observer = new IntersectionObserver(entries => entries.forEach(entry => applyActive(entry.isIntersecting)), {
            rootMargin: `-${Math.max(0, window.innerHeight - zone)}px 0px 0px 0px`
        });
        observer.observe(anchor);
    };
    document.addEventListener(NUDGE_REQUEST_EVENT, event => {
        const {lane: lane} = event.detail ?? {};
        if (lane !== "bottom-left" && lane !== "all") return;
        log("events", "nudge-request received", {
            lane: lane,
            active: active
        });
        if (!mobileMq.matches) return;
        if (active) emitEdge(measureEdgeY(), true);
    });
    window.addEventListener("scroll", () => {
        if (active) scheduleFrame();
    }, {
        passive: true
    });
    new ResizeObserver(() => scheduleFrame()).observe(gallery);
    const onLoadSettle = () => {
        if (!mobileMq.matches) return;
        if (active) scheduleFrame();
    };
    if (document.readyState === "complete") onLoadSettle(); else window.addEventListener("load", onLoadSettle, {
        once: true
    });
    const onBreakpointChange = () => {
        if (mobileMq.matches) buildObserver(); else {
            observer?.disconnect();
            observer = null;
            applyActive(false);
        }
    };
    const onResize = debounce(() => {
        if (!mobileMq.matches) return;
        buildObserver();
        if (active) scheduleFrame();
    }, 150);
    mobileMq.addEventListener("change", onBreakpointChange);
    window.addEventListener("resize", onResize, {
        passive: true
    });
    if (mobileMq.matches) buildObserver();
    log("lifecycle", "pdp widget anchor initialized", {
        anchor: caption ? "caption" : "media-track"
    });
})();